import { Component, OnInit, HostListener, Input } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { Product } from 'src/app/shared/classes/product';
import { ProductSevenComponent } from 'src/app/shared/components/product/product-seven/product-seven.component';

import { ApiService } from 'src/app/shared/services/api.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'shop-sidebar-page',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
})

export class SidebarPageComponent implements OnInit {	
	product = [];
	perPage = 12;
	type = 'list';
	totalCount = 0;
	orderBy = 'default';
	pageTitle = 'List';
	toggle = false;
	searchTerm = '';
	loaded = false;
	firstLoad = false;
	productsShowing=0;
	params: any;
	brandid = -1;
	subcats = [];
	category = '';
	subcategory='-1';
	brands=[];
	brands_img_path='';
	popular_cats_img_path='';	

	constructor(public activeRoute: ActivatedRoute, public router: Router, public utilsService: UtilsService, public apiService: ApiService, private titleService:Title, private meta:Meta) {
		this.meta.updateTag({name:'keywords',content:'test test test'});
		this.activeRoute.params.subscribe(async params => {
			this.type = params['type'];
			//this.pageTitle = params['subcategory'];			
			
			if (this.type == 'list') {
				this.pageTitle = 'List';
			} else if (this.type == '2cols') {
				this.pageTitle = 'Grid 2 Columns';
			} else if (this.type == '3cols') {
				this.pageTitle = 'Grid 3 Columns';
			} else if (this.type == '4cols') {
				this.pageTitle = 'Grid 4 Columns';
			}
			
		});
		
		this.activeRoute.queryParams.subscribe(async params => {
			this.loaded = false;
			this.params = params;

			if (params['searchTerm']) {
				this.searchTerm = params['searchTerm'];
				this.pageTitle = 'Search Results';
			} else {
				this.searchTerm = '';
			}

			if (params['orderBy']) {
				this.orderBy = params['orderBy'];
			} else {
				this.orderBy = 'default';
			}

			if(params['subcategory']){
				this.subcategory = params['subcategory'];	
				let cat_name = await lastValueFrom(this.apiService.execSqlQueryPromise('SELECT * FROM ProductCategories WHERE CatID =' + params['subcategory'] +' AND DELETEDFLAG=0'));
				this.pageTitle =  cat_name[0].CatDescription.toString();
			}

			if(params['title']){
				this.pageTitle = params['title'];
			}

			if(params['brand']){
				this.brandid = params['brand'];
				//if selected brand is in the category select show all the items of that brand from that category
				if(params['subcategory'] != undefined){
					this.subcategory = params['subcategory'];
				}				
			}
			
			if(params['category']){
				this.category = params['category'];				
			}

			if(params['brandName']){
				this.pageTitle = params['brandName'];
			}

			if(params['perPage']){
				this.perPage = params['perPage'];
			}
			else{
				this.perPage = 12;
			}

			
		})
	}

	async ngOnInit(): Promise<void> {
		this.titleService.setTitle(this.pageTitle);				
		if (window.innerWidth > 991) this.toggle = false;
		else this.toggle = true;

		if(typeof window !== 'undefined'){
			if(this.apiService.db_conn_string == null || this.apiService.db_conn_string == ''){
				await this.apiService.fetchDBconnStringPromise();
			}

			let result = await lastValueFrom(this.apiService.fetchShopDataPromise(this.params, this.perPage));
			this.product = result.products;
			this.apiService.products = this.product;
			this.totalCount = result.totalCount;
			if(this.product.length < this.perPage)
			{
				this.productsShowing = result.totalCount;	
			}
			else
			{
				this.productsShowing = this.product.length * this.apiService.page_number;						
				
			}				
			this.loaded = true;
			if (!this.firstLoad) {
				this.firstLoad = true;
			}

			if (this.apiService.show_master_categories_home_page && this.category != ''){
				this.subcats =  await this.apiService.fetchSubCats(this.category);
				this.popular_cats_img_path = environment.Images_Path+ this.apiService.img_folder+"/popular/";

			}

			if(this.subcategory != '-1'){
				this.brands= await lastValueFrom(this.apiService.fetchProductsBrandsPromise(this.subcategory));
				this.brands_img_path = environment.Images_Path+ this.apiService.img_folder+"/brands/";	
			}
			

			this.utilsService.scrollToPageContent();
		}
	}

	@HostListener('window: resize', ['$event'])
	onResize(event: Event) {
		if (window.innerWidth > 991) this.toggle = false;
		else this.toggle = true;
	}

	changeOrderBy(event: any) {
		this.router.navigate([], { queryParams: { orderBy: event.currentTarget.value, page: 1 }, queryParamsHandling: 'merge' });
	}

	toggleSidebar() {
		if (document.querySelector('body').classList.contains('sidebar-filter-active'))
			document.querySelector('body').classList.remove('sidebar-filter-active');
		else
			document.querySelector('body').classList.add('sidebar-filter-active');
	}

	hideSidebar() {
		document.querySelector('body').classList.remove('sidebar-filter-active');
	}

	changePerPage(event: any){
		this.router.navigate([],{queryParams: {perPage: event.currentTarget.value, page:1}, queryParamsHandling: 'merge'});

	}

	//navigate to the same page but changing params does not work on iphone
	routerClicked(id:any, brandname:any, subcat:any){
		//let url = "/3cols?brand="+id+"&brandName="+brandname+"&subcategory="+subcat;
		//this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		//this.router.navigate(['/shop/sidebar/3cols/'],{queryParams: {brand: id, brandName:brandname,subcategory:subcat}, queryParamsHandling: ''});
	}
}